import { c as _c } from "react/compiler-runtime";
import React from 'react';
const InstallIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.4096 13.0687C8.75339 13.0687 9.04304 12.7954 9.04304 12.4638V3.05699L8.99593 1.74451L9.70942 2.47315L11.1576 3.97944C11.273 4.10555 11.4331 4.17328 11.5838 4.17328C11.9182 4.17328 12.1702 3.93274 12.1702 3.61513C12.1702 3.44465 12.1018 3.31854 11.9747 3.2041L8.87115 0.205513C8.7228 0.0467083 8.57207 0 8.41195 0C8.25183 0 8.11291 0.0467083 7.95279 0.205513L4.84922 3.2041C4.73383 3.31854 4.66554 3.44465 4.66554 3.61513C4.66554 3.93507 4.90808 4.17328 5.22833 4.17328C5.38845 4.17328 5.56271 4.10555 5.67573 3.97944L7.12391 2.47315L7.83741 1.73283L7.7809 3.05465V12.4615C7.77854 12.7954 8.07758 13.0687 8.4096 13.0687ZM3.23622 20H13.5853C15.4126 20 16.3333 19.0986 16.3333 17.3213V8.29052C16.3333 6.52265 15.4126 5.61187 13.5853 5.61187H11.0563V6.87763H13.5618C14.5037 6.87763 15.057 7.37973 15.057 8.36058V17.256C15.057 18.2368 14.506 18.7389 13.5618 18.7389H3.25976C2.30609 18.7389 1.77628 18.2368 1.77628 17.256V8.36058C1.77628 7.37973 2.30609 6.87763 3.25976 6.87763H5.78876V5.61187H3.23622C1.42071 5.61187 0.5 6.51331 0.5 8.29052V17.3213C0.5 19.1009 1.42071 20 3.23622 20Z" fill="#0279FB" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default InstallIcon;